import {ProjectUserType} from "@natomas-org/core";

export const findUserOfProject = (
  obj: Record<string, ProjectUserType>,
  value: ProjectUserType
): string | undefined => {
  return Object.keys(obj).find((key) => obj[key] === value);
};
